import React, { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { ToastProvider } from "./context/ToastContext.jsx";
import useAuthStore from "./store/authStore.jsx";
import LoginPage from "./pages/LoginPage.jsx";
import AdminPanel from "./pages/AdminPanel.jsx";
import AdminUserManagement from "./pages/AdminUserManagement.jsx";
import TVDisplay from "./pages/TVDisplay.jsx";
import TvListPage from "./pages/TvListPage.jsx"; 
import PrivateRoute from "./components/PrivateRoute.jsx";

function App() {
  const { initialize, initialized } = useAuthStore();

  useEffect(() => {
    initialize();
  }, [initialize]);

  if (!initialized) {
    return (
      <ToastProvider>
        <div
          style={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
          }}
        >
          <div
            style={{
              width: "40px",
              height: "40px",
              border: "4px solid #f3f3f3",
              borderTop: "4px solid #667eea",
              borderRadius: "50%",
              animation: "spin 1s linear infinite",
            }}
          ></div>
          <p
            style={{
              marginTop: "20px",
              color: "#666",
              fontSize: "14px",
              fontWeight: "500",
            }}
          >
            🔄 앱을 초기화하는 중...
          </p>
          <style jsx>{`
            @keyframes spin {
              0% {
                transform: rotate(0deg);
              }
              100% {
                transform: rotate(360deg);
              }
            }
          `}</style>
        </div>
      </ToastProvider>
    );
  }

  return (
    <ToastProvider>
      <div className="App">
        <Routes>
          {/* 메인 페이지 - TV 목록 */}
          <Route path="/" element={<TvListPage />} />

          {/* 로그인 페이지 */}
          <Route path="/login" element={<LoginPage />} />

          {/* 관리자 패널 (인증 필요) */}
          <Route
            path="/admin"
            element={
              <PrivateRoute>
                <AdminPanel />
              </PrivateRoute>
            }
          />

          {/* 관리자 사용자 관리 (인증 필요) */}
          <Route
            path="/admin/users"
            element={
              <PrivateRoute>
                <AdminUserManagement />
              </PrivateRoute>
            }
          />

 {/* 기존 /tv 경로들 (하위 호환성을 위해 유지) */}
          <Route path="/tv/:tvName" element={<TVDisplay />} />
          <Route path="/tv" element={<TVDisplayLegacy />} />

          {/* 새로운 동적 TV 디스플레이 라우트 (가장 마지막에 배치) */}
          <Route path="/:tvName" element={<TVDisplay />} />
        </Routes>
      </div>
    </ToastProvider>
  );
}

// 기존 쿼리 파라미터 방식을 새로운 형태로 리다이렉트하는 컴포넌트
const TVDisplayLegacy = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const tvId = searchParams.get("id");

  if (tvId) {
    // 기존 /tv?id=tvName을 /{tvName}으로 리다이렉트
    return <Navigate to={`/${tvId}`} replace />;
  }

  // ID가 없으면 메인 페이지로
  return <Navigate to="/" replace />;
};

export default App;
